export async function initApp (Hammer, AppContainer, makeApp, initModules) {
  Hammer.install();

  const app = await makeApp(Hammer);

  await initModules(app);

  app.start(AppContainer);
}
